export function formatToLocalTime(utcString) {
  const date = new Date(utcString + 'Z'); // Ensure it's treated as UTC
  return date.toLocaleDateString(undefined, {
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });
}

export function isToday(date) {
  const today = new Date();
  const input = new Date(date);
  return input.toDateString() === today.toDateString();
}